





























































































































































import { Component, Vue } from 'vue-property-decorator';
import ButtonMagnetic from '../components/ButtonMagnetic.vue';
import ButtonNextPage from '../components/ButtonNextPage.vue';
import Globecity from '../components/Globecity.vue';
import {Expo, Linear, TimelineMax, TweenMax} from 'gsap';
import $ from 'jquery';
import {i18n} from '../plugin/i18n';
import {Meta} from '../decorators/decorators';


@Component({
    components: {Globecity, ButtonNextPage, ButtonMagnetic},


    mounted: function() {

        // on passe le logo et le burger en blanck
        this.$events.fire('app-whitelogo');

        let cities = ['china', 'usa', 'newyork', 'tokyo', 'world', 'germany', 'sweden'];
        let citiesCircles: Array<JQuery>  = [];
        let citiesPaths: Array<JQuery> = [];
        cities.forEach((el) => {
            citiesPaths.push($('#path-' + el));
            citiesCircles.push($('.globecity-' + el));
        });


        let t = new TimelineMax({delay: 0});
        t.add([
            TweenMax.fromTo(this.$refs.globe, 1.5, {alpha: 0, y: 80}, {delay: 0.3, alpha: 1, y:0}),
            TweenMax.staggerFromTo(citiesCircles, 1.5, {alpha: 0, y: 10}, {delay: 1.5, alpha: 1, y:0}, 0.4),
            TweenMax.staggerFromTo(citiesPaths, 1.5, {alpha: 0}, {delay: 1.5, alpha: 1.5}, 0.4),
        ]);

    },

    beforeDestroy: function(){
        this.$events.fire('app-darklogo');
    }
})
export default class GlobeTrekker extends Vue {
    @Meta
    myMetaConfig() {
        return {
            title:  i18n.t('GlobeTrekker.title')
        }
    }
}
